// extracted by mini-css-extract-plugin
export default {"summary":"sumary_summary__xvYE+","summaryTitle":"sumary_summaryTitle__UzABQ","summaryText":"sumary_summaryText__SQDOd"};